import React from 'react';
import Sortable from 'react-sortablejs';
import CategoryItem from './CategoryItem';
import {columnStyle, titleStyle} from './styles';

export default function Category({
  title,
  items = [],
  disableItems = [],
  toggleItemStatus,
  preview = false,
  sortable = false,
  onDragItem,
  onDragSubItem,
  isSupportSubOptions = false,
  type = 'enable',
}) {
  return (
    <div style={columnStyle}>
      <div style={titleStyle}>{title}</div>
      {sortable ? (
        <Sortable
          options={{handle: '.draggable'}}
          tag="div"
          onChange={onDragItem}
        >
          {items.map(item => (
            <CategoryItem
              key={item.value}
              item={item}
              toggleItemStatus={toggleItemStatus}
              preview={preview}
              isDisabled={false}
              isSupportSubOptions={isSupportSubOptions}
              type={type}
              sortable={sortable}
              onDragSubItem={onDragSubItem}
            />
          ))}
        </Sortable>
      ) : (
        <div>
          {items.map(item => (
            <CategoryItem
              key={item.value}
              item={item}
              isDisabled={disableItems.includes(item.value)}
              toggleItemStatus={toggleItemStatus}
              preview={preview}
              isSupportSubOptions={isSupportSubOptions}
              type={type}
            />
          ))}
        </div>
      )}
    </div>
  );
}
